import { Component, Input, OnInit } from '@angular/core';
import { ProvisionEnvironment } from '../../enums/provision-environment.enum';
import { Account } from '../../../app/models/account.model';
import { AccountStatus } from '../../../app/enums/account-status.enum';
import { environment } from '../../../environments/environment';
import { AccountType } from 'src/app/enums/account-type.enum';
@Component({
  selector: 'account-summary',
  templateUrl: './account-summary-alt.component.html',
  styleUrls: ['./account-summary-alt.component.scss'],

})

export class AccountSummaryComponent implements OnInit {
  @Input() account:any;
  statusIcon: string = '';
  statusToolTip: string = '';
  yammerUrl: string = environment.yammerURl;

  // TODO: Get actual values from Logan later on
  // adGroupList: string[] = ['aws208610-d1-tds-main-emily-test', 'aws208610-d1-tds-main-test-emily', 'aws208610-d1-ngo-emily-test'];

  constructor() { }

  ngOnInit(): void {    
    this.statusDisplay(this.account.accountStatus)
  }

  openAws() {
    window.open(environment.awsUrl, '_blank');
  }

  openAzure() {
    window.open(environment.azureUrl, '_blank');
  }

  statusDisplay(statusId: number) : string {
    switch(statusId) {
      case AccountStatus.Completed:
        this.statusIcon = '../../assets/images/circle-check.svg';
        this.statusToolTip = 'Account provisioned';
        return "Completed"
      case AccountStatus.Error:
        this.statusIcon = '../../assets/images/error-pulse.svg';
        this.statusToolTip = 'There was an error creating your account. Please contact the Maxis team on Viva Engage at Maxis Cloud AI & Analytics';
        return "Error"
      case AccountStatus.NotStarted:
        return "Not Started"
      case AccountStatus.Pending:
        this.statusIcon ='../../assets/images/loader.svg';
        this.statusToolTip ='Account creation in progress';
        return "Pending"
      default:
        return ""
    }
  }

  environmentDisplay(environmentId: number) : string{
    return ProvisionEnvironment[environmentId];
  }

  getAccountTypeImage(typeId: number) : string{
    switch(typeId){
      case AccountType.AWS: 
        return "../../../assets/images/aws-logo.svg";
      case AccountType.Azure: 
        return "../../../assets/images/azure-logo.svg";
      default:
        return " ";
    }
  }

  accountTypeDisplay(typeId: number) :string {
    return AccountType[typeId];
  }

  public get AccountStatus() {
    return AccountStatus; 
  }


}
